import React, { useCallback, useEffect, useState } from 'react'
import GModal from 'tennders-market/common/components/element/GModal'
import useMultipleCostInvoiceForm from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceForm'
import useMultipleLineForm from 'tennders-finance/cost-invoice/hooks/useMultipleLineForm'
import useMultipleCostInvoicePreview from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoicePreview'
import useMultipleCostInvoiceCalculateAmounts from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoiceCalculateAmounts'
import MultipleCostInvoiceOutput from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceOutput'
import MultipleCostInvoiceExtraCostsTable from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceExtraCostsTable'
import MultipleCostInvoiceLines from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceLines'
import MultipleCostInvoiceDiscountsTable from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceDiscountsTable'
import MultipleCostInvoiceSaveButton from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceSaveButton'
import MultipleCostInvoiceDrafts from 'tennders-finance/cost-invoice/components/multiple-cost-invoice/MultipleCostInvoiceDrafts'
import GHref from 'tennders-market/common/components/element/GHref'
import PubSub from 'pubsub-js'
import { apiGet } from 'tennders-stracture/libs/api'
import AddOrderDocument from 'tennders-documents/views/AddOrderDocument'
import useTranslation from 'next-translate/useTranslation'
import useMultipleCostInvoicePaymentTerm from 'tennders-finance/cost-invoice/hooks/useMultipleCostInvoicePaymentTerm'
import { dateToStr } from 'tennders-stracture/libs/utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import MultipleCostInvoiceGeneralInfo from '../components/multiple-cost-invoice/MultipleCostInvoiceGeneralInfo'

const MultipleCostInvoiceModal = ({ onClose, selectedTransaction, initialForm }) => {
  const {
    onChange,
    setForm,
    company,
    setCompany,
    form,
    errors: formErrors,
    setErrors: setFormErrors,
    onCompanyChange,
    calculatesDueDate,
    onDueDateChange,
    onDateOfReceiptChange,
    fetchCostInvoices,
    costInvoices
  } = useMultipleCostInvoiceForm({ selectedTransaction, initialForm })
  const { t } = useTranslation('costInvoice')
  const [deletable, setDeletable] = useState(false)

  const onVatChange = (vat) => setForm({ ...form, defaultVat: vat })

  const {
    errors: lineErrors,
    setLines,
    setErrors: setLineErrors,
    lines,
    removeLine,
    onFormChange,
    addNewLine
  } = useMultipleLineForm()

  const {
    errors: discountErrors,
    setLines: setDiscountLines,
    lines: discountLines,
    removeLine: removeDiscountLine,
    onFormChange: onDiscountFormChange,
    addNewLine: onNewAddDiscountLine
  } = useMultipleLineForm()

  const {
    errors: extraCostsErrors,
    setLines: setExtraCostLines,
    lines: extraCostsLines,
    removeLine: removeExtraCostsLine,
    onFormChange: onExtraCostsFormChange,
    addNewLine: onNewAddExtraCostsLine
  } = useMultipleLineForm()

  const {
    addButton,
    documents,
    setDocuments
  } = useMultipleCostInvoicePreview()

  const {
    totalExtraCosts,
    totalExtraCostsIncVat,
    totalAmountOnInvoice,
    calculateTotalDiscount,
    totalEndAmountToPay,
    totalDiscount,
    totalAmountOnInvoiceIncVat,
    totalIRPF,
    totalVatAmount
  } = useMultipleCostInvoiceCalculateAmounts({
    form,
    lines,
    discountLines,
    extraCostsLines
  })

  const {
    onPaymentTermChange,
    allPaymentTerms,
    selectedPaymentTerm,
    paymentTermProblem
  } = useMultipleCostInvoicePaymentTerm({
    calculatesDueDate,
    lines,
    form,
    onChange,
    company
  })

  const transactionProblem = useCallback(
    () => lines?.filter(line => !!line.referenceNumber).length === 0,
    [lines]
  )

  const publishLines = (key, lines) => {
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i]
      PubSub.publish(
        `${key}:${line.id}:change`,
        line
      )
    }
  }

  useEffect(() => {
    console.info('ss', selectedPaymentTerm)
    const lines = [...discountLines]
    if (selectedPaymentTerm?.discount) {
      lines[0].value = selectedPaymentTerm.discount
      lines[0].concept = (selectedPaymentTerm?.type?.code || selectedPaymentTerm?.type) + ' Discount'
      lines[0].pt = true
      setDiscountLines([...lines])

      setTimeout(() => publishLines('multiple-cost-invoice-discount', lines), 100)
    } else if (lines[0].value && lines[0]?.pt) {
      lines[0].value = null
      lines[0].concept = 'Discount'
      lines[0].pt = false
      setDiscountLines([...lines])

      setTimeout(() => publishLines('multiple-cost-invoice-discount', lines), 100)
    }
  }, [selectedPaymentTerm])
  const initAll = (initialForm) => {
    setForm({ ...initialForm })
    if (initialForm.company) {
      apiGet('/companies/' + initialForm.company).then((company) => {
        setCompany(company)
      })
    }
    setLines(initialForm.lines)
    setTimeout(() => publishLines('multiple-cost-invoice', initialForm.lines), 400)
    if (initialForm.paymentTerm) {
      onPaymentTermChange('paymentTerm', initialForm.paymentTerm)
    }
    if (initialForm.discountLines) {
      setTimeout(() => {
        setDiscountLines(initialForm.discountLines)
      }, 400)
      setTimeout(() => publishLines('multiple-cost-invoice-discount', initialForm.discountLines), 400)
    }
    if (initialForm.extraCostsLines) {
      setExtraCostLines(initialForm.extraCostsLines)
      setTimeout(() => publishLines('multiple-cost-invoice-extra-cost', initialForm.extraCostsLines), 400)
    }
  }

  const selectDraft = (draft) => {
    initAll({ ...draft.oplog, draftId: draft.id })
    if (draft?.oplog?.documents) {
      setDocuments(draft.oplog?.documents)
    }
  }

  const handleDocumentChange = (documents) => {
    setDocuments(documents)
    onChange('documents', documents.map(doc => doc.id))
  }

  const deleteDocument = (documentId) => {
    const docs = documents.filter(doc => doc.id !== documentId)
    if (docs.length === 0) {
      window.alert(t('force_upload_another_document'))
      return
    }
    handleDocumentChange(docs)
  }

  useEffect(() => {
    if (form.creditNoteFor && !form.id) {
      apiGet('/costInvoice/' + form?.creditNoteFor).then((creditNote) => {
        delete creditNote.oplog['id']
        initAll({ ...creditNote.oplog, creditNoteFor: creditNote.id, creditNote: true, invoiceNo: '' })
      })
    }
  }, [form?.creditNoteFor])

  useEffect(() => {
    if (initialForm) {
      if (initialForm.deletable) {
        setDeletable(true)
      }
      if (initialForm.documents) {
        setDocuments(initialForm.documents)
      }

      if (initialForm.oplog) {
        initAll({
          ...initialForm.oplog,
          status: initialForm.status,
          approveEnabled: initialForm.approveEnabled,
          id: initialForm.id
        })
      } else {
        setForm({ ...initialForm })
      }
      if (initialForm.id && initialForm.toCompany) {
        onCompanyChange(initialForm.toCompany)
      }
    }
  }, [initialForm])

  if (documents?.length === 0) {
    return (
      <GModal isOpen close={onClose as any} size="100%">
        <>
          <div className="d-flow row">
            <div
              style={{ overflow: 'auto' }}
              className="d-flex column  w-100"
            >
              <h2 className="mb-20">
                {t('uploadYourInvoice')}
              </h2>
              <div>
                {addButton}
              </div>
              <div className="pt-12">
                {t('chooseDraftPrompt')}
              </div>
            </div>
            <div className="d-flex column vh-100 w-100">
              <MultipleCostInvoiceDrafts selectDraft={selectDraft} />
            </div>
          </div>
        </>
      </GModal>
    )
  }

  return (
    <GModal
      isOpen
      close={onClose as any}
      size="100%"
      extraStyle={{ height: '100%', overflow: 'auto' }}
    >
      <div className="tennders-modal-body w-100">
        <h3 className="bold">
          {t('uploadAndMatch')}
        </h3>
        <div className="d-flex row justify-space">
          <MultipleCostInvoiceGeneralInfo
            form={form}
            editDisabled={false}
            costInvoices={costInvoices}
            onVatChange={onVatChange}
            allPaymentTerms={allPaymentTerms}
            formErrors={formErrors}
            onCompanyChange={onCompanyChange}
            onChange={onChange}
            onDateOfReceiptChange={onDateOfReceiptChange}
            onDueDateChange={onDueDateChange}
            onPaymentTermChange={onPaymentTermChange}
            fetchCostInvoices={fetchCostInvoices}
            selectedTransaction={selectedTransaction}
            company={company}
          />
          <div className="hr"></div>
          <MultipleCostInvoiceLines
            removeLine={removeLine}
            form={form}
            onFormChange={onFormChange}
            addNewLine={addNewLine}
            lines={lines}
            selectedTransaction={selectedTransaction}
            selectedPaymentTerm={selectedPaymentTerm}
            errors={lineErrors}
          />
          <MultipleCostInvoiceExtraCostsTable
            defaultVat={form?.defaultVat}
            editMode={form?.id}
            reversedVat={form?.reversedVat}
            removeExtraCostsLine={removeExtraCostsLine}
            extraCostsErrors={extraCostsErrors}
            extraCostsLines={extraCostsLines}
            companyId={form.company}
            onExtraCostsFormChange={onExtraCostsFormChange}
            onNewAddExtraCostsLine={onNewAddExtraCostsLine}
          />
          <MultipleCostInvoiceDiscountsTable
            defaultVat={form?.defaultVat}
            reversedVat={form?.reversedVat}
            discountErrors={discountErrors}
            onDiscountFormChange={onDiscountFormChange}
            totalAmountOnInvoice={totalAmountOnInvoice}
            totalExtraCosts={totalExtraCosts}
            discountLines={discountLines}
            companyId={form.company}
            onNewAddDiscountLine={onNewAddDiscountLine}
            removeDiscountLine={removeDiscountLine}
            lines={lines}
          />
          <div className="d-flex row justify-end w-100">
            <MultipleCostInvoiceOutput
              {...{
                creditNote: form?.creditNote,
                totalExtraCosts,
                totalIRPF,
                totalExtraCostsIncVat,
                totalAmountOnInvoice,
                totalEndAmountToPay,
                totalDiscount,
                totalAmountOnInvoiceIncVat,
                calculateTotalDiscount,
                totalVatAmount
              }}
            />
          </div>
          <AddOrderDocument
            title={form.document?.path || t('attachCostInvoice')}
            type="cost_invoice"
            handleUpload={(_, document) => {
              handleDocumentChange([...documents, { ...document, deletable: true }])
            }}
            id={undefined}
          />
          <div className="d-flex column justify-end w-100">
            {documents?.filter(doc => doc && (doc.name || doc.path))
              ?.map((doc, index) => (
                <p key={doc.id}><span className="bold">( {index + 1} )</span>
                  <GHref
                    target="_blank"
                    href={doc.fullUri}
                  >
                    {doc.name || doc.path} uploaded by <i>{doc.createdByStr} </i> at {dateToStr(doc.createdAtStr)}
                    {doc.deletable && (
                      <GHref
                        onClick={() => deleteDocument(doc.id)}
                        className="ml-10 mb-20"
                      >
                        <FontAwesomeIcon icon={faXmark} className="mr-4" />
                      </GHref>
                    )}
                  </GHref>
                </p>
              ))}
          </div>
          <div className="hr"></div>
          <MultipleCostInvoiceSaveButton
            lines={lines}
            form={form}
            changes={initialForm?.changes}
            deletable={deletable}
            calculations={{
              totalExtraCosts,
              totalIRPF,
              totalExtraCostsIncVat,
              totalAmountOnInvoice,
              totalEndAmountToPay,
              totalAmountOnInvoiceIncVat,
              calculateTotalDiscount,
              totalVatAmount
            }}
            paymentTermProblem={paymentTermProblem}
            selectedTransaction={selectedTransaction}
            transactionProblem={transactionProblem()}
            setLineForm={onFormChange}
            discountLines={discountLines}
            documents={documents}
            totalExtraCostsIncVat={totalExtraCostsIncVat}
            extraCostsLines={extraCostsLines}
            setFormErrors={setFormErrors}
            setLineErrors={setLineErrors}
            onClose={onClose}
          />
        </div>
        <div className="w-100 mt-40">
          <div className="video-wrapper-3-4 d-grid" style={{ minHeight: 500 }}>
            {documents && documents[documents.length - 1].fullUri ? (
              <iframe
                title="a"
                src={documents[documents.length - 1].fullUri}
                height="100%"
                width="100%">
              </iframe>
            ) : null}
          </div>
        </div>
      </div>
    </GModal>
  )
}

export default MultipleCostInvoiceModal
